var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnhanceImageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.713 13.052v12.18H6.767V6.286h12.18V3.579H6.767A2.732 2.732 0 0 0 4.06 6.286v18.946a2.732 2.732 0 0 0 2.707 2.707h18.946a2.7 2.7 0 0 0 2.707-2.707v-12.18h-2.707m-2.707 0 1.272-2.788 2.788-1.272-2.787-1.272-1.272-2.788-1.272 2.788-2.788 1.272 2.788 1.272 1.272 2.788m-5.075 1.015-1.692-3.721-1.692 3.722-3.721 1.691 3.722 1.692 1.692 3.722 1.692-3.722 3.722-1.692Z",
    fill: "currentColor",
    "data-name": "Path 497"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhanceImageIcon);
export default __webpack_public_path__ + "static/media/enhanceImageIcon.5119570cc05b94ec17e4c06aacb72c98.svg";
export { ForwardRef as ReactComponent };